import React from "react";
import { Button } from "bootstrap";
import  About  from "./contactus/views/Main/About"
const AboutUs = () => {


    return (
        <About />
     );

}
   

export default AboutUs;